
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.365 10.762l4.066 4.066M23.356 8.216L17.02 14.55M28.582 7.913l3.983 3.983","stroke":"#000C1F","stroke-width":"2","stroke-linecap":"round"}}),_c('circle',{attrs:{"cx":"4.522","cy":"8.243","r":"3.522","stroke":"#000C1F","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"25.748","cy":"5.407","r":"3.522","stroke":"#3DAFB8","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"14.25","cy":"17.289","r":"3.522","stroke":"#000C1F","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"35.478","cy":"14.446","r":"3.522","stroke":"#000C1F","stroke-width":"2"}}),_c('rect',{attrs:{"y":"29.81","width":"38.949","height":"1.77","rx":".885","fill":"#000C1F"}})])
          )
        }
      }
    